import { BlankChange } from '@doltech/ui/lib/figma/BlankEditor/DoTest/Blank';
import { EditableContainer } from '@doltech/ui/lib/figma/BlankEditor/DoTest/BlankEditorDoTest';
import { BlankElement } from '@doltech/ui/lib/figma/BlankEditor/DoTest/MobileBlankElement';
import { BlankItem } from '@doltech/ui/lib/figma/BlankEditor/type';
import { withBlank } from '@doltech/ui/lib/figma/BlankEditor/withBlank';
import { noop } from 'lodash';
import * as React from 'react';
import { createEditor, Node } from 'slate';
import { Editable, ReactEditor, Slate, withReact } from 'slate-react';

interface BlankEditorDoTestProps {
  no?: number;
  editorValue?: Node[];
  blanks?: BlankItem[];
  blankValues?: BlankChange[];
  onRemoveBlank: (input: any) => void;
  editor?: ReactEditor;
  showRemoveButton?: boolean;
  onBlankClick?: any;
  userAnswers: any;
}

const BLankMobileEditor = (props: BlankEditorDoTestProps) => {
  const {
    no,
    editorValue,
    blanks,
    onBlankClick,
    userAnswers,
    onRemoveBlank,
    editor: editorFromProps = withBlank(withReact<any>(createEditor())),
    ...rest
  } = props;
  const [editor] = React.useState(editorFromProps);

  const renderElement = React.useCallback(
    (renderProps) => {
      return (
        <BlankElement
          onRemoveBlank={onRemoveBlank}
          onBlankClick={onBlankClick}
          {...renderProps}
          {...rest}
          blanks={blanks}
          userAnswers={userAnswers}
          no={no}
          placeholder="bấm để chọn đáp án"
        />
      );
    },
    [onRemoveBlank, onBlankClick, rest, blanks, userAnswers, no]
  );
  return (
    <Slate editor={editor} initialValue={editorValue} onChange={noop}>
      <EditableContainer>
        <Editable readOnly renderElement={renderElement} />
      </EditableContainer>
    </Slate>
  );
};

export default React.memo(BLankMobileEditor);
